import React from "react";

import ContentLoader from 'react-content-loader';

function LoadingBranch() {
  let width = 100;

  return (<>
    <ContentLoader
        speed={3}
        width={340}
        height={84}
        viewBox="0 0 340 84"
        backgroundColor="#696969"
        foregroundColor="#363636"
    >
        <rect x="0" y="0" rx="3" ry="3" width="67" height="11" />
        <rect x="76" y="0" rx="3" ry="3" width="140" height="11" />
        <rect x="106" y="48" rx="3" ry="3" width="53" height="11" />
        <rect x="166" y="48" rx="3" ry="3" width="72" height="11" />
        <rect x="0" y="48" rx="3" ry="3" width="100" height="11" />
        <rect x="0" y="71" rx="3" ry="3" width="37" height="11" />
        <rect x="0" y="23" rx="3" ry="3" width="140" height="11" />
        <rect x="148" y="23" rx="3" ry="3" width="173" height="11" />
        <rect x="44" y="71" rx="3" ry="3" width="173" height="11" />
    </ContentLoader>
  </>);
}

export default LoadingBranch;
